<template>
    <v-col cols="12" sm="12">
        <v-container class="app-container">
            <home-title
                :title="$t('stillQuestions')"
            ></home-title>

            <div class="d-flex align-center justify-center pb-10">
                <before-button></before-button>
                <home-button
                    :text="$t('contactUs')"
                    @click="$emit('open-faq-dialog')"
                ></home-button>
                <after-button></after-button>
            </div>
        </v-container>
    </v-col>
</template>

<script>
    import AfterButton from '../../../general/svg-icons/AfterButton';
    import BeforeButton from '../../../general/svg-icons/BeforeButton';
    import HomeButton from './HomeButton';
    import HomeTitle from './HomeTitle';

    export default {
        name: 'HomeQuestions',
        components: {
            AfterButton,
            BeforeButton,
            HomeButton,
            HomeTitle,
        },
    }
</script>

<style scoped>

</style>
